import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const carouselSlides = [
    {
      id: 1,
      image: '/1.png',
    },
    {
      id: 2,
      image: '/2.png'
    },
    {
      id: 3,
      image: '/3.png'
    },
    {
      id: 4,
      image: '/4.png'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      //setCurrentSlide((prev) => (prev + 1) % carouselSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [carouselSlides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };



  return (
    <section id="home" className="hero">
      <div className="hero-carousel-container">
        <div className="carousel-wrapper">
          <div 
            className="carousel-slides" 
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {carouselSlides.map((slide, index) => (
              <div 
                key={slide.id} 
                className={`carousel-slide 'bg-image-slide'}`}
                style={{
                  backgroundImage: `url(${slide.image})`,
                  backgroundSize:  'cover',
                  backgroundPosition: 'center top',
                  backgroundRepeat: 'no-repeat',
                  backgroundColor: 'transparent'
                }}
              >
                {slide.showContent && (
                  <div className="slide-content-wrapper-custom">
                    <div className="slide-right-content">
                      <h1 className="slide-main-title">GROWTH WITH US</h1>
                      <p className="slide-company-name">ELIBS SOLUTIONS (PVT) LTD</p>
                      <div className="slide-logo-container">
                        <img src="/logo.png" alt="ELIBS Solutions" className="slide-logo" />
                      </div>
                      <p className="slide-website">www.elibssolutions.com</p>
                      <div className="slide-contact-info">
                        <div className="contact-item">
                          <span className="contact-icon">📞</span>
                          <span className="contact-text">+94713167976</span>
                        </div>
                        <p className="director-name">Director : W.R. Sanjeewa</p>
                        <div className="contact-item whatsapp">
                          <span className="contact-icon">💬</span>
                          <span className="contact-text whatsapp-text">+94713167976</span>
                        </div>
                      </div>
                      <p className="slide-address">242, GEMUNU MAWATHA, KOTUWEGODA, RAJAGIRIYA, COLOMBO, SRI LANKA, 10107</p>
                    </div>
                  </div>
                )}
                {slide.headline && !slide.showContent && (
                  <>
                    <div className="slide-overlay"></div>
                    <div className="slide-content-wrapper">
                      <div className="container">
                        <div className="slide-content">
                          <div className="slide-text-content">
                            <h1 className="slide-headline">
                              {slide.headline} {slide.highlight && <span className="highlight-text">{slide.highlight}</span>}
                            </h1>
                            {slide.subheadline && <p className="slide-subheadline">{slide.subheadline}</p>}
                            {slide.ctaText && (
                              <button 
                                className="btn btn-primary slide-cta"
                                onClick={() => scrollToSection(slide.ctaLink.substring(1))}
                              >
                                {slide.ctaText}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
        
        <button 
          className="carousel-arrow-side carousel-arrow-left"
          onClick={() => goToSlide((currentSlide - 1 + carouselSlides.length) % carouselSlides.length)}
          aria-label="Previous slide"
        >
          ‹
        </button>
        <button 
          className="carousel-arrow-side carousel-arrow-right"
          onClick={() => goToSlide((currentSlide + 1) % carouselSlides.length)}
          aria-label="Next slide"
        >
          ›
        </button>
      </div>
    </section>
  );
};

export default Hero;
